var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGoodBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#GoodBg_svg__a)",
  d: "M0 0h21v22.906a2 2 0 0 1-2.821 1.824l-6.858-3.088a2 2 0 0 0-1.642 0L2.82 24.73A2 2 0 0 1 0 22.906V0Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "GoodBg_svg__a",
  x1: 10.5,
  x2: 10.5,
  y1: 0,
  y2: 26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00C6A2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#008B72"
})))));
export default SvgGoodBg;